import Wizard from '../../components/wizard/Wizard';
import CustodiansWizardContent from './CustodiansWizardContent';
import useAddCustodianWizard from '../../hooks/Locations/addLocation/useAddCustodianWizard';
import useAddCustodianLookups from '../../hooks/Locations/addLocation/useAddCustodianLookups';
import DiscardWizardModal from '../../Modals/DiscardWizardModal';

export default function CustodianWizard() {
  const {
    states,
    custodianTypes,
    phoneTypes,
    portalTypes,
    sourceTypes,
    recordTypes,
    serveMethods,
    supportedOrderTypes,
    paymentMethods,
    timeZones,
    departmentFileTypes,
    days,
    followUpMethods
  } = useAddCustodianLookups();

  const {
    cancelClickHandler,
    saveClickHandler,
    mainInfoForm,
    cancelDiscard,
    discard,
    isDiscardModalOpened,
    isSaving,
    copyCustodianAddress,
  } = useAddCustodianWizard({
    states,
    custodianTypes,
    phoneTypes,
    portalTypes,
    sourceTypes,
    recordTypes,
    supportedOrderTypes,
    departmentFileTypes,
    followUpMethods
  });

  return (
    <>
      <DiscardWizardModal
        isModalOpened={isDiscardModalOpened}
        handleClose={cancelDiscard}
        handleAgree={discard}
      />
      <Wizard
        isSaving={isSaving}
        onSaveClicked={saveClickHandler}
        onCancelClicked={cancelClickHandler}
      >
        <CustodiansWizardContent
          mainInfoForm={mainInfoForm}
          custodianTypes={custodianTypes}
          paymentMethods={paymentMethods}
          phoneTypes={phoneTypes}
          portalTypes={portalTypes}
          sourceTypes={sourceTypes}
          recordTypes={recordTypes}
          serveMethods={serveMethods}
          states={states}
          timeZones={timeZones}
          departmentFileTypes={departmentFileTypes}
          days={days}
          supportedOrderTypes={supportedOrderTypes}
          copyCustodianAddress={copyCustodianAddress}
          followUpMethods={followUpMethods}
        />
      </Wizard>
    </>
  );
}
